

















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class WebsiteIcon extends Vue {
  @Prop({ default: '24' }) readonly size?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
